import { useState } from 'react';
import Image, { ImageProps } from 'next/image';
import styles from './styles.module.css';

const ImageWithLoader = ({ ...props }: ImageProps) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  return (
    <div className="relative">
      {isImageLoading && <div className={styles.loader} />}
      <Image onLoad={() => setIsImageLoading(false)} {...props} />
    </div>
  );
};

export default ImageWithLoader;
